import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import MultiDataForm from "../MultiFormData";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const EditTemplateRoute = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        template_name: "",
        entity_id: null,
        description: "",
    });
    const [childFormData, setChildFormData] = useState(null)
    const [entityList, setEntityList] = useState([]);
    const [otherLists, setOtherLists] = useState()

    useEffect(() => {

        (async () => {
            try {
                const response = await CrudService.getRouteTemplateUtils();
                if(response.success){
                    setEntityList(response.entity)
                    setOtherLists(response)
                }
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
        (async () => {
            try {
                if(id){
                    const response = await CrudService.getSingleRouteTemplate(id);
                    if(response.success){
                        setFormData({
                            template_name: response.template.template_name,
                            description: response.template.description,
                            entity_id: response.template.entity_id
                        })
                        let maped = new Set(response.template.RouteTemplateValues.map((e) => e.condition_group_id))
                        maped = [...maped.values()]
                        let childForm = response.template.RouteTemplateValues.map((e, i) => ({
                            group_id: maped.findIndex((a) => a == e.condition_group_id) + 1,
                            condition_group_id: e.RouteConditionGroup.logic_operator,
                            comparison_operator_id: e.comparison_operator_id,
                            condition_type_id: e.condition_type_id,
                            parameter_id: e.parameter_id,
                            value: e.value,
                            alert_type_id: e.alert_type_id                   
                        }))
                        setChildFormData(childForm)
                    }
                }
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
    }, [id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        let groupedConditions = childFormData.reduce((acc, condition) => {
            let groupId = condition.group_id;
            if (!acc[groupId]) acc[groupId] = [];
            acc[groupId].push(condition);
            return acc;
        }, {});

        const templates = {
            ...formData,
            values: groupedConditions
        }

        try {
          await CrudService.updateRouteTemplate(templates, id);
          navigate("/route-template", {
            state: { value: true, text: "The route template was successfully updated" },
          });
          toast.success("The route template was successfully updated")
        } catch (err) {
          console.error(err);
          toast.error(err.error)
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Add New Route Template
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox component="form" onSubmit={submitHandler} >
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>

                                    <TextField fullWidth label="Template Name" name="template_name" value={formData.template_name} onChange={handleChange} margin="normal"  required/>
                                    <TextField fullWidth label="Description" name="description" value={formData.description} onChange={handleChange} margin="normal" />
                                    <FormControl fullWidth margin="normal">
                                        <InputLabel>Entity</InputLabel>
                                        <Select label="Entity" name="entity_id" value={formData.entity_id ?? ''} onChange={handleChange} sx={{ height: '40px' }} required>
                                            {
                                                entityList.length && entityList.map((elm) => (
                                                    <MenuItem key={elm.entity_id} value={elm.entity_id}>{elm.name || elm.first_name}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    {
                                        childFormData && otherLists ?
                                        <MultiDataForm listData={otherLists} setChildFormData={setChildFormData} childFormData={childFormData} /> : ''
                                    }
                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/route-template", {
                                                        state: { value: false, text: "" },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit" >
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default EditTemplateRoute;
